import { Directive, ElementRef, HostListener, Input } from '@angular/core';

/**
 * Shows native title tooltip only when text is truncated (ellipsis).
 * Uses the same overflow detection as CSS truncation: scrollWidth > clientWidth.
 */
@Directive({
  selector: '[cygovTooltipIfTruncated]',
  standalone: true,
})
export class TooltipIfTruncatedDirective {
  @Input() cygovTooltipIfTruncated: string = '';

  constructor(private el: ElementRef<HTMLElement>) {}

  @HostListener('mouseenter')
  onMouseEnter(): void {
    const element = this.el.nativeElement;
    const text = this.cygovTooltipIfTruncated || element.textContent?.trim() || '';
    if (!text) {
      return;
    }
    const isTruncated = element.scrollWidth > element.clientWidth;
    if (isTruncated) {
      element.setAttribute('title', text);
    } else {
      element.removeAttribute('title');
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.el.nativeElement.removeAttribute('title');
  }
}
